import React from "react";
import { CONFIG } from "../../../config"


function CopyRight() {

  const today = new Date();
  const year = today.getFullYear();


  return (
    <div className="copyright">
      <h6>Aliv Copyright ® {year} <small>({CONFIG.APP_VERSION})</small></h6>
    </div>
  );
}

export default CopyRight;
